// footer.jsx
// autor: WdePaula
// data/revisão: 26/12/24 | 17h32 | corrigido o número do WhatsApp e o Email que estavam totalmente errados;




import React from "react";
import './footer.css';

function Footer() {
    const ano = new Date().getFullYear();
    return (
        <section id="footer">    
            <div>
                <ul className="list-unstyled list-inline social text-center">
                    <li className="list-inline-item">
                        <a href="https://instagram.com/_agendex" target="_blank" rel="noreferrer">
                            <i className="fab fa-instagram fa-2x"></i>
                        </a>
                    </li>						
                    <li className="list-inline-item">
                        <a href="https://youtube.com/microvolution" target="_blank" rel="noreferrer">
                            <i className="fab fa-youtube fa-2x"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a href="https://api.whatsapp.com/send?phone=5531995525753&text=Ol%C3%A1%2C%20estou%20no%20site%20Agendex,%20e%20gostaria%20de%20mais%20informações!" target="_blank" rel="noreferrer">
                            <i className="fab fa-whatsapp fa-2x"></i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a href="mailto:microvolution.informatica@gmail.com" target="_blank" rel="noreferrer">
                            <i className="fas fa-envelope fa-2x"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <p className="h6">© 2021-{ano} Agendex. Todos os direitos reservados.</p>
            </div>
        </section>
    );
}

export default Footer;